module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (239).b02e6368.jpg";